var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-field-label-pane__option-field-pane" },
    [
      _c("PtVirtualTree", {
        ref: "wTreeCompRef",
        staticClass: "custom-field-label-pane__option-field-pane__list",
        attrs: {
          "item-class": "custom-field-label-pane__option-field-pane__item",
          "item-min-item-size": 32,
          data: _vm.field.field_option_value,
          "node-key": "option_id",
          filter: _vm.filter,
          "filter-node-method": _vm.filterNodeMethod,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var data = ref.data
              return [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toggleCheck(data.option_id)
                      },
                    },
                  },
                  [
                    _c("PtIcon", {
                      class: {
                        active: _vm.isChecked(data.option_id),
                      },
                      attrs: {
                        icon: _vm.isChecked(data.option_id)
                          ? "SolidCheckboxOn"
                          : "SolidCheckboxOff",
                      },
                    }),
                    _c("div", {
                      staticClass:
                        "custom-field-label-pane__option-field-pane__item__name",
                      domProps: {
                        innerHTML: _vm._s(_vm.getNodeName(data.option_text)),
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "empty",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-field-label-pane__option-field-pane__no-data",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.filter
                            ? _vm.$t(
                                "PtCustomFieldLabelPane.editor.filter." +
                                  _vm.field.field_type +
                                  ".noFilterData"
                              )
                            : _vm.$t(
                                "PtCustomFieldLabelPane.editor.filter." +
                                  _vm.field.field_type +
                                  ".noData"
                              )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }